// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c557a36","455":"64d59d97"}[chunkId] + ".chunk.js";
};